import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import SearchTags, { SearchTagHandle } from "../../../components/SearchTags";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter  
} from "@progress/kendo-react-grid";
import { ODataProvider } from "../../../contexts/ODataContext";
import { EntityService } from "../../../services/EntityService";
import { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";
import { Link } from "react-router-dom";
import "react-toggle/style.css";
import Toggle from 'react-toggle';
import { CommonLibrary } from "../../../contexts/CommonContext";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";


const AddEntitiesToProject: React.FC = () => {

  // Define properties and hooks
  const entityService = new EntityService();
  const commonLibrary = new CommonLibrary();
  const { t } = useTranslation();
  const API_URL = config.API_URL;
  const searchList = {
    Label: t("general.search"),
    PlaceHolder: t("general.searchByTags"),
    TextField: "Description",
    KeyField: "Id",
    PageSize: 10,
    baseUrl: API_URL + "/odata/Tags"
  }

  const entityApiUrl = config.API_URL + "/odata/Entities";
  const [value, setValue] = React.useState<any[]>([]);
  const [filterType, setFilterType] = React.useState<number>(1);
  const dataGridRef = useRef<DataGridHandle>(null);
  const searchTagRef = useRef<SearchTagHandle>(null);
  const [selectedItems, setSelectedItems] = React.useState<number[]>([]);
  const [toggleActive, setToggleActive] = React.useState(false);


  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };
  // Define the columns

  const columns = [] as ColumnCustomProps[];
  columns.push({ field: "Description", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columns.push({ field: "ProjectDescriptions", title: t("general.projects"), columnMenu: ColumnMenu, isExportable: true });
  columns.push({ field: "Tags", title: t("general.tags"), columnMenu: undefined, isExportable: true });

  // Define the event handlers
  const onClickSearch = () => {
    entityService.UpdateMyEntitiesFilter({ Tags: value.map(a => a.Description), WhereType: filterType }).then(() => {
      dataGridRef.current?.refreshData();
      entityService.UpdateMyEntitiesFilter({ Tags: [], WhereType: 1 });
    });
  }

  const onFilterTypeChange = (filterType: number) => {
    setFilterType(filterType);
  }

  const onSetValue = (event: MultiSelectChangeEvent) => {
    setValue(event.target.value);
  }

  const onSelectedItemsChange = (selectedItems: number[]) => {
    setSelectedItems(selectedItems);
  }

  const handleToggle = () => {
    setToggleActive(!toggleActive);
    if (!toggleActive) {
      dataGridRef.current?.filterData(undefined);
    }
    else {
      dataGridRef.current?.filterData({
        logic: "and",
        filters: [
          {
            field: "IsAssignedToProject",
            operator: "eq",
            value: false
          }
        ]
      });
    }
  }

  const handleAddEntitiesToProject = () => {
    if (selectedItems.length > 0) {
      const entityModel = { ProjectId: commonLibrary.ProjectId, ObjectIds: selectedItems };
      entityService.AddEntitiesToProject(entityModel).then(() => {
        dataGridRef.current?.refreshData();
      });
    }
  }

  React.useEffect(() => {
    dataGridRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "IsAssignedToProject",
          operator: "eq",
          value: false
        }
      ]
    });
  }, []);

  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/entities"> 
           <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">
          <div>
            <h5 className="title"><Trans>configuration.entities.addEntitiesToProject</Trans></h5>
          </div>
          <Row className="pt-4">
            <Col sm={8} >
              <Row>
              <Col sm={7}>
                <ODataProvider baseUrl={searchList.baseUrl} loadingContent=".k-multiselect">
                  <SearchTags ref={searchTagRef} KeyField={searchList.KeyField} Label={searchList.Label} PageSize={searchList.PageSize} PlaceHolder={searchList.PlaceHolder} TextField={searchList.TextField} onFilterTypeChange={onFilterTypeChange} onSetValue={onSetValue} />
                </ODataProvider>
              </Col>
              <Col sm={4} className="pt-4">               
                <Button themeColor="secondary" onClick={onClickSearch}>
                <SvgIcon className="btn-icons" icon={svgIcons.searchIcon} size="medium" /> <Trans>general.search</Trans></Button>                
              </Col>
              </Row>
            </Col>            
          </Row>
        </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">
          <Row>
            <Col sm={2}>
              <Toggle
                defaultChecked={toggleActive}
                icons={false}
                onChange={handleToggle} />
              <span style={{ "paddingLeft": "11px", "bottom": "6px", "position": "relative" }}><Trans>general.showAllData</Trans></span>
            </Col>
            <Col sm={12}>
              <ODataProvider baseUrl={entityApiUrl} loadingContent=".k-grid-content">
                <DataGridCustom PermissionButtonCode="menu_entities" ShowAddButton={true} onAddButtonClick={handleAddEntitiesToProject} ref={dataGridRef} DataItemKey="EntityId" Columns={columns} onSelectedItemsChange={onSelectedItemsChange} />
              </ODataProvider>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AddEntitiesToProject;
